<template>
  <el-container class="curri_content">
    <el-header>
      <index-header></index-header>
    </el-header>
    <el-main>
      <div class="mainContent">
        <p @click="back()" style="margin-bottom:10px;"><i class="icon el-icon-arrow-left"></i>{{$t('global.backToSchedule')}}</p>
        <div class="main-arrow">
          <el-tabs v-model="activeTitle" type="card" @tab-click="handleClick">
            <el-tab-pane :label="$t('payList.creditTitle')" name="credit" class="credit">
              <my-credit :data-credit="creditData"></my-credit>
            </el-tab-pane>
            <el-tab-pane :label="$t('payList.paymentTitle')" name="payment" class="payment">
              <my-payment :data-payment="paymentData"></my-payment>
            </el-tab-pane>
          </el-tabs>
          <!-- <div class="main-info">
            <div class="select-part">
              <el-select v-model="subData" collapse-tags placeholder="Select a Subject">
                  <el-option v-for="item in getSub"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                    @change="search(item)">{{item.title}}</el-option>
              </el-select>
            </div> -->

        </div>
      </div>
    </el-main>
    <el-footer>
      <index-footer></index-footer>
    </el-footer>
  </el-container>
</template>

<script>
import { setStore, getStore, keys } from '@/store';
import IndexHeader from './views/header'
import MyCredit from './views/credit'
import MyPayment from './views/payment'
import IndexFooter from './views/footer'
export default {
  components: {
    IndexHeader,
    MyCredit,
    MyPayment,
    IndexFooter
  },
  name: 'payHistory',
  data () {
    return {
      activeTitle: 'credit',
      creditData: {},
      paymentData: {}
    }
  },
  created () {
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/sinadd'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
    }
    this.getSubjects()
  },
  methods: {
    back () {
      this.$router.push({ path: '/index' })
    },
    handleClick (tab, event) {
      if (tab.name == 'credit') {
        this.getCredit()
      } else if (tab.name == 'payment') {
        debugger;
        return;
        this.getPayment()
      }
    },
    getSubjects () {
      this.$http.get('/api/edu/subjects').then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.getSub = res.data.data
          this.getSub.map((item, i) => {
            if (item.id == this.courseData.subject_id) {
              this.subInfo = item
            }
          })
          // store.setChildList(res.data.data);
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    getCredit () {
      this.$http.get('/api/account-logs/creditPC?type=&credit_value=&start_at=' + '&end_at=' +
       '&time_diff=' + this.utils.timeZone() + '&pagesize=10&page=1').then((res) => {
        if (res.data.code == 200) {
          this.creditData = res.data
          // this.total = res.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getPayment () {
      this.$http.get('/api/account-logs/recharge?start_at=&end_at=&time_diff=' + this.utils.timeZone() +
      '&pagesize=10&page=1').then((res) => {
        if (res.data.code == 200) {
          this.paymentData = res.data
          // this.total = res.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.curri_content{
  position: relative;
  .el-header{
    height: 88px!important;
    background: rgba(53,54,67,0.90);
    width: 100%;
    padding:0;
  }
  .el-main{
    overflow: inherit;
    padding:0;
    margin-bottom:254px;
    z-index:22;
    .mainContent{
      width:1200px;
      margin:25px auto 54px;
      .main-arrow{
        padding:30px;
      }
    }
  }
  .el-footer{
    width:100%;
    height:inherit!important;
    padding:0;
    position: absolute;
    bottom:0;
  }

  // tab切换
  /deep/ .el-tabs--card{
    .el-tabs__header{
      border:none;
      margin: 0;
      // .el-tabs__nav-wrap{
      //   margin-bottom:0;
      // }
      .el-tabs__nav{
        border:none;
        border-radius: 0;
        .el-tabs__item{
          background: rgba(248,248,248,0.80);
          border-radius: 5px 5px 0px 0px;
          border: 1px solid #a5a5a5;
          border-bottom:none;
          font-size: 18px;
          color: #a5a5a5;
          margin-left:4px;
          margin-right:16px;
          font-family: Sofia Pro-Regular;
          &.is-active{
            border: 1px solid #ffd1c6;
            background: #ffd1c6;
            color: #ff6440;
            font-family: Sofia Pro-Bold;
            box-shadow: 4px 4px 5px 0px rgba(255,100,64,0.15);
          }
        }
      }
    }
    .el-tabs__content{
      background: #fff;
      border: 1px solid #ffd1c6;
      border-radius: 6px;
      .el-tab-pane{
        margin:25px 28px 55px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/payHistory.vue